import DOMPurify from 'dompurify'

export const purifyAndAllowHtmlTags = string => {
  const config = {
    ALLOWED_TAGS: ['span', 'strong', 'br', 'mark'],
    ALLOWED_ATTR: ['class', 'style'],
  }
  return DOMPurify.sanitize(string, config)
}
